var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "511.618px",
    height: "409.7px",
    viewBox: "0 0 511.618 409.7",
    enableBackground: "new 0 0 511.618 409.7",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.743,197.922l-68.934-57.664V12.5c0-5.964-4.835-10.8-10.8-10.8h-59.4c-5.965,0-10.8,4.835-10.8,10.8v60.001 L282.856,9.802c-4.438-3.707-22.865-15.981-45.625-5.935c-0.751,0.253-1.479,0.595-2.175,1.021c0,0,0,0,0,0l0,0 c-0.445,0.273-0.88,0.569-1.293,0.913L3.876,197.922c-4.578,3.824-5.188,10.636-1.364,15.213l20.131,24.097 c3.824,4.579,10.635,5.188,15.212,1.365L255.615,56.613l218.147,181.984c4.578,3.823,11.389,3.214,15.213-1.365l20.131-24.097 C512.931,208.558,512.32,201.747,507.743,197.922z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.643,84.783L72.81,234.688V391.7c0,9.941,8.059,18,18,18h123v-122h83v122h123c9.941,0,18-8.059,18-18V235.318 L255.643,84.783z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.7b0c5446291fe70efcc5c96eb74ec17e.svg";